<div id="page-wrapper" [ngClass]="page.customClass">
  <div id="header__builder">
    @if (!isPohPage && !isAPohPdp) {
      @if (page.extraData.components?.global) {
        <app-global-announcement-banner />
      }

      @if (page.extraData.components?.advantage) {
        <app-advantages-banner />
      }
    }
  </div>

  @if (page.extraData.components?.header) {
    <app-header (mobileOpenEvent)="mobileOpenEvent($event)" />
  }

  @if (!isPohPage && !isAPohPdp && page.extraData.components?.globalTimer) {
    <app-timer [mode]="'global'" />
  }

  <main role="main">
    @if (page.extraData.components?.breadcrumbs) {
      <app-breadcrumb />
    }
    <router-outlet />
  </main>

  @if (page.extraData.components?.footer) {
    <app-footer />
  }
</div>
